jQuery(function () {
  initStickyHeader();
});

function initStickyHeader() {
  var header = jQuery('.header');

  if (jQuery(window).scrollTop() > 0) {
    header.addClass('fixed');
  } else {
    header.removeClass('fixed');
  }
}

jQuery(window).on('scroll', function () {
  initStickyHeader();
});